
import React from 'react'

import KanbanColumn from './KanbanColumn'

import './Kanban.scss'

type Props = {
  height: number,
  columns: any,
  onSelectTask: any,
}

const Kanban = (props: Props) => {

  return (
    <div className='kanban-container table-responsive scroller scroll-x no-scroll-y'>
      <div className="kanban" style={{
        width: (props.columns.length * 320) - 15,
      }}>
        {props.columns.map((column: any, i: number) => (
          <KanbanColumn
            key={i}
            icon={column.icon}
            title={column.title}
            tasks={column.tasks}
            className={column.className}
            onSelectTask={props.onSelectTask}
          />
        ))}
      </div>
    </div>
  )
}

export default Kanban
